import { Fragment, useState } from "react";
import { Cell } from "../../../components/table/styles";
import { Question } from "../../../types/quize";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  IconButton,
  TableRow,
  TableCell,
  Collapse,
  Checkbox,
  List,
  ListItem,
} from "@mui/material";

export default function QuestionRow(
  props: Question & { index: number; onDelete: () => void }
) {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <TableRow>
        <Cell>{props.index}</Cell>
        <Cell width="70%">{props.title}</Cell>
        <Cell width="10%">
          <IconButton onClick={() => setOpen(!open)}>
            {open ? (
              <ArrowDropUp sx={{ color: "divider" }} />
            ) : (
              <ArrowDropDown sx={{ color: "divider" }} />
            )}
          </IconButton>
        </Cell>
        <Cell
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton onClick={props.onDelete}>
            <DeleteIcon sx={{ color: "divider" }} />
          </IconButton>
        </Cell>
      </TableRow>
      <TableRow sx={{ bgcolor: "primary.dark" }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List>
              {props.options.map((option, index) => {
                return (
                  <ListItem key={index}>
                    <Checkbox
                      value={index}
                      checked={index === props.answer}
                      color="secondary"
                    />
                    {option}
                  </ListItem>
                );
              })}
            </List>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
